import localDb from "@util/localDb";
import {queryOrgTree} from "@api/core/org";

// 按模块的action, reducer整合体
const GET_ORGANIZATION_LIST = "GET_ORGANIZATION_LIST";

const loopFormatOrgTree = data => {
  data.map(item => {
    if (item.children && item.children.length < 1) {
      delete item.children;
    } else if (item.children && item.children.length > 0) {
      loopFormatOrgTree(item.children);
    }
    return item;
  });
};

// Action
export function getOrganization() {
  return dispatch => {
    queryOrgTree().then(res => {
      if (res.statusCode === 200) {
        localDb.set(GET_ORGANIZATION_LIST, res.data);
        loopFormatOrgTree(res.data);
        return dispatch({
          type: GET_ORGANIZATION_LIST,
          data: res.data,
        });
      }
    });
  };
}

// Reducer
export function organization(state = [], action) {
  switch (action.type) {
    case GET_ORGANIZATION_LIST:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/organization.js